import { useEffect, useState } from 'react';
import axios from 'axios';
import language from '../../variables/language';
// .student-lessons-stat-pill lives here - imported explicitly rather than
// relying on a sibling component (GroupLessonsList.jsx) already pulling it
// in as a global side effect.
import '../../css/student-card.css';

export default function GroupStats({ groupId, refresh }) {
  const [totalLessons, setTotalLessons] = useState(0);
  const [particles, setParticles] = useState([]);

  useEffect(() => {
    axios.get('/api/lessons?groupe=' + groupId, { withCredentials: true })
      .then(response => setTotalLessons((response.data || []).length))
      .catch(() => {});
    axios.get('/api/events/infopanel?groupe=' + groupId, { withCredentials: true })
      .then(response => setParticles(response.data || []))
      .catch(() => {});
  }, [groupId, refresh]);

  const particleValue = (name) => {
    const found = particles.find(p => p.name === name);
    return found ? found.value : '0';
  };

  const lang = language[language.lang];

  const tiles = [
    { value: totalLessons, label: lang.groupCard.statsTotalLessons },
    { value: particleValue('Sum hours'), label: lang['Sum hours'] },
    { value: particleValue('Sum price'), label: lang['Sum price'] },
    { value: particleValue('Sum attendance'), label: lang['Sum attendance'] },
    { value: particleValue('Sum absence'), label: lang['Sum absence'] },
    { value: particleValue('Sum paid'), label: lang['Sum paid'] },
  ];

  // Compact pills (same look as Events.jsx's own toolbar stats), not the
  // bulkier standalone .conv-progress-stat boxes this used to render as its
  // own full-width row - moved into the group card header alongside the
  // title/icons, so it needs to be small enough to actually fit there.
  return (
    <div className="student-lessons-stats group-card-header-stats">
      {tiles.map((tile, index) => (
        <span className="student-lessons-stat-pill" key={index}>
          <b>{tile.value}</b><small>{tile.label}</small>
        </span>
      ))}
    </div>
  );
}
